export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") ||
  "https://www.duxai.com.au";

export const SITE_NAME = "Dux AI";
export const SITE_TAGLINE =
  "AI-powered product trainers. Instant expert guidance for Dux and Thermann hot water systems.";

export const PHONE = "1300 365 115";
export const PHONE_HREF = "tel:1300365115";
export const EMAIL = "duxaftersales@dux.com.au";
export const EMAIL_HREF = "mailto:duxaftersales@dux.com.au";

export const COMPANY = {
  legalName: "Dux Manufacturing Limited",
  abn: "19 077 879 844",
  privacyEmail: "privacy@dux.com.au",
  privacyPhone: "1300 365 115",
  privacyPhoneHref: "tel:1300365115",
  postalAddress:
    "Attention: Dux Privacy Officer, Lackey Rd, Moss Vale NSW 2577, Australia",
  mainPrivacyUrl: "https://www.dux.com.au/privacy",
} as const;

export const ROUTES = [
  { path: "/",         title: "Home" },
  { path: "/blog",     title: "Blog" },
  { path: "/thermann", title: "Thermann AI Trainers" },
  { path: "/privacy",  title: "Privacy Policy" },
] as const;

/* ─── TRAINER LISTS ─────────────────────────────────────────── */

export type TrainerStatus = "live" | "soon";

export interface Trainer {
  name: string;
  status: TrainerStatus;
  /** External URL (only set for live trainers). */
  href?: string;
  /** Brief description shown in cards. */
  description?: string;
}

/**
 * Trainers shown on the main Dux AI hub (www.duxai.com.au).
 * First entry is live; the rest are coming soon.
 */
export const MAIN_TRAINERS: Trainer[] = [
  {
    name: "Thermann Products",
    status: "live",
    href: "https://www.thermann.duxai.com.au",
    description:
      "Ask anything about Thermann hot water systems — troubleshooting, installation, and more.",
  },
  {
    name: "Heat Pump Systems",
    status: "soon",
    description: "AI trainer coming soon for Dux heat pump hot water systems.",
  },
  {
    name: "Gas Storage",
    status: "soon",
    description: "Dedicated trainer for gas storage hot water units.",
  },
  {
    name: "Electric Storage",
    status: "soon",
    description: "Expert guidance for electric storage hot water systems.",
  },
  {
    name: "Gas Continuous Flow",
    status: "soon",
    description: "Instant help with gas continuous flow units.",
  },
  {
    name: "Commercial Systems",
    status: "soon",
    description: "AI trainer for commercial hot water and HVAC solutions.",
  },
];

/**
 * Trainers shown on the Thermann brand sub-hub (thermann.duxai.com.au).
 * First entry is live; the rest are coming soon.
 */
export const THERMANN_TRAINERS: Trainer[] = [
  {
    name: "Smart Electric",
    status: "live",
    href: "https://www.smartelectric.thermann.duxai.com.au",
    description:
      "AI-powered support for the Thermann Smart Electric heat pump water heater.",
  },
  {
    name: "Heat Pump",
    status: "live",
    href: "https://www.heatpumpc.thermann.duxai.com.au",
    description:
      "AI-powered support for the Thermann Heat Pump hot water range.",
  },
  {
    name: "Gas Storage",
    status: "soon",
    description: "Coming soon.",
  },
  {
    name: "Electric Storage",
    status: "soon",
    description: "Coming soon.",
  },
  {
    name: "Gas Continuous Flow",
    status: "soon",
    description: "Coming soon.",
  },
  {
    name: "Commercial Systems",
    status: "soon",
    description: "Coming soon.",
  },
];
